import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from '../shared/Constants/sharedConstants';

@Injectable()
export class HasFeatureFlagGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!route.data.featureFlag) {
      return true;
    }

    if (!AppSettings.UIAppConfig.features) {
      return this.router.parseUrl('/dashboard');
    }

    const hasFeature = AppSettings.UIAppConfig?.features[route.data.featureFlag] === true;
    return hasFeature ? true : this.router.parseUrl('/dashboard');
  }
}
